var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19515_77775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87239 9.97661L11.2874 10.0513L11.5098 5.80673L7.26529 5.58429L7.19116 6.9988L9.02029 7.09516L5.05286 10.6675L6.00079 11.7202L9.96823 8.14795L9.87239 9.97661Z",
    fill: "#CE1111",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.708252 13.4585C0.708252 14.2099 1.00676 14.9306 1.53812 15.462C2.06947 15.9933 2.79014 16.2918 3.54159 16.2918H13.4583C14.2097 16.2918 14.9304 15.9933 15.4617 15.462C15.9931 14.9306 16.2916 14.2099 16.2916 13.4585V3.54183C16.2916 2.79038 15.9931 2.06971 15.4617 1.53836C14.9304 1.00701 14.2097 0.708496 13.4583 0.708496H3.54159C2.79014 0.708496 2.06947 1.00701 1.53812 1.53836C1.00676 2.06971 0.708252 2.79038 0.708252 3.54183V13.4585ZM3.54159 14.8752H13.4583C13.834 14.8752 14.1943 14.7259 14.46 14.4602C14.7257 14.1946 14.8749 13.8342 14.8749 13.4585V3.54183C14.8749 3.16611 14.7257 2.80577 14.46 2.5401C14.1943 2.27442 13.834 2.12516 13.4583 2.12516H3.54159C3.16586 2.12516 2.80553 2.27442 2.53985 2.5401C2.27417 2.80577 2.12492 3.16611 2.12492 3.54183V13.4585C2.12492 13.8342 2.27417 14.1946 2.53985 14.4602C2.80553 14.7259 3.16586 14.8752 3.54159 14.8752Z",
    fill: "#CE1111",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19515_77775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBorder);
export default __webpack_public_path__ + "static/media/arrow_border.b958c9ca6b4f5edc22e0276a383d8e9b.svg";
export { ForwardRef as ReactComponent };